import { createEntityWithDefaults } from "actions/entities";
import { fetchEntities } from 'actions/entities'
import SchemaForm from 'components/forms/SchemaForm'
import dotProp from "dot-prop";
import React from 'react'
import { connect } from 'react-redux'
import { Message } from "semantic-ui-react";
import consultationReminderSchema from "../../forms/consultationReminderSchema";

class ConsultationReminderForm extends React.Component {
  componentDidMount() {
    this.props.fetchEntities()
  }

  render () {
    return (
      <React.Fragment>
        {this.props.readonly ? <Message>{I18n.t('api.forms.not_in_scope')}</Message> : null}
        <SchemaForm entityName="consultationReminder" {...this.props}/>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let readonly = dotProp.get(state, `entities.consultationReminder.byId.${ownProps.entityId}.readOnly`)

  return {
    uiSchema: consultationReminderSchema(state, {...ownProps, readonly: readonly}),
    readonly: readonly
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchEntities: () => {
      dispatch(fetchEntities('consultationReminders'))
      dispatch(fetchEntities('emailTemplates'))
    },
  }
}

ConsultationReminderForm.defaultProps = {
  submitButton: true
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsultationReminderForm);
